import { toast, Zoom } from 'react-toastify'

export const renderAiToast = () => {
  toast.success(
    <p className="whitespace-nowrap text-sm font-semibold text-primary-normal lg:text-lg">
      AI가 추천한 맞춤 강의로 이동할게요
    </p>,
    {
      toastId: 'aiToast',
      className:
        'top-6 px-4 lg:px-5 py-2.5 lg:top-12 rounded-full mx-auto border-2 border-primary w-auto shadow-[0px_10px_66px_0px_rgba(189, 97, 27, 0.10)]',
      bodyClassName: 'p-0 flex items-center justify-center text-sm lg:text-base font-semibold',
      closeButton: false,
      icon: (
        <div className="flex h-6 w-[42px] shrink-0 items-center justify-center lg:h-[30px] lg:w-15">
          <img
            src="https://d35ai18pny966l.cloudfront.net/course/home/icon_AI.png"
            alt="check icon"
            className="w-full"
          />
        </div>
      ),
      style: {
        backgroundColor: 'white',
        width: '100%',
      },
      transition: Zoom,
    },
  )
}
